{
  "OrganizationTalentsPage": {
    "title": "Talenty organizacji"
  },
  "ResourceTypesSettingsMenu": {
    "triggerLabel": "Konfiguruj typy zasobów",
    "heading": "Konfiguruj typy zasobów",
    "allTypes": "Wszystkie typy",
    "global": "W tej organizacji",
    "workspace": "W tej przestrzeni",
    "thisTypeInWorkspace": "{{name}} w tej przestrzeni"
  },
  "ResourceRowGallery": {
    "failedToLoad": "Nie udało się załadować pinów",
    "empty": "Brak pinów",
    "addContactPins": "Dodaj piny"
  },
  "AssignResourcesToWorkspacesDialog": {
    "title": "Przypisz do przestrzeni roboczych",
    "description_one": "Wybierz widoczność {{name}} w przestrzeniach roboczych.",
    "description_other": "Wybierz widoczność tych {{count}} zasobów w przestrzeniach roboczych.",
    "fieldScope": "Widoczność",
    "scopeHidden": "Ukryty",
    "scopeHiddenHint": "Brak członkostwa — niewidoczny na listach (tylko admin).",
    "scopeGlobal": "Globalny",
    "scopeGlobalHint": "Widoczny w każdej przestrzeni (wiersz członkostwa bez id przestrzeni).",
    "scopeWorkspaces": "Wybrane przestrzenie",
    "fieldWorkspaces": "Przestrzenie robocze",
    "workspacesSelectPrompt": "Wybierz jedną lub więcej przestrzeni roboczych",
    "workspacesSelectedCount": "Wybrano: {{count}}",
    "workspacesUnselectAll": "Odznacz wszystkie",
    "workspacesEmpty": "Brak dostępnych przestrzeni roboczych",
    "save": "Przypisz",
    "assignFailed": "Nie udało się przypisać przestrzeni roboczych",
    "unsavedChangesBeforeUnload": "Masz niezapisane zmiany!",
    "success_one": "Zasób przypisany do przestrzeni roboczych",
    "success_other": "Przypisano {{count}} zasobów do przestrzeni roboczych"
  },
  "ResourceWorkspacesCell": {
    "hidden": "Ukryty",
    "global": "Globalny"
  },
  "ResourceCreateForm": {
    "profilePicture": "Zdjęcie profilowe",
    "resourceType": "Typ zasobu"
  },
  "ResourceCreateDialog": {
    "title": "Utwórz zasób",
    "titleTypeAndVisibility": "Utwórz zasób · typ i widoczność",
    "titleType": "Utwórz zasób · typ",
    "titleDetails": "Utwórz zasób · szczegóły",
    "description": "Utwórz nowy zasób",
    "actions": {
      "add-another": "Zapisz i dodaj kolejny",
      "go-to-profile": "Zapisz i przejdź do profilu",
      "close": "Zapisz"
    },
    "createFailed": "Nie udało się utworzyć zasobu",
    "noResourceTypes": "Brak dostępnych typów zasobów."
  },
  "CreateDraftSummary": {
    "change": "Zmień"
  },
  "ResourceDuplicatesFooter": {
    "title": "Wygląda znajomo?",
    "titleExact": "Ktoś o tej nazwie już istnieje",
    "summary_one": "{{count}} istniejący zasób ma podobną nazwę",
    "summary_few": "{{count}} istniejące zasoby mają podobną nazwę",
    "summary_many": "{{count}} istniejących zasobów ma podobną nazwę",
    "summary_other": "{{count}} istniejących zasobów ma podobną nazwę",
    "summaryNamed_one": "{{count}} istniejący zasób przypomina „{{name}}”",
    "summaryNamed_few": "{{count}} istniejące zasoby przypominają „{{name}}”",
    "summaryNamed_many": "{{count}} istniejących zasobów przypomina „{{name}}”",
    "summaryNamed_other": "{{count}} istniejących zasobów przypomina „{{name}}”",
    "review": "Sprawdź",
    "hide": "Ukryj",
    "dismiss": "Odrzuć",
    "exactMatch": "Ta sama nazwa",
    "similarMatch": "Podobny",
    "openProfile": "Otwórz",
    "openProfileOf": "Otwórz profil {{name}} w nowej karcie",
    "hint": "Profile otwierają się w nowej karcie, więc szkic zostaje tutaj. To inna osoba? Po prostu zapisz."
  },
  "ResourceSchema": {
    "coreLabel": {
      "fullName": "Imię i nazwisko",
      "pronouns": "Zaimki",
      "emails": "Adresy e-mail",
      "phoneNumbers": "Numery telefonów",
      "socials": "Media społecznościowe",
      "websites": "Strony internetowe",
      "tags": "Tagi",
      "groups": "Grupy",
      "locations": "Lokalizacje",
      "rates": "Stawki",
      "agent": "Agent",
      "organization": "Organizacja",
      "nickname": "Pseudonim",
      "role": "Rola"
    },
    "enterPlaceholder": "Wpisz: {{label}}",
    "globalSection": "Globalne",
    "locationItemTitle": "Lokalizacja",
    "rateItemTitle": "Stawka",
    "addRate": "Dodaj stawkę",
    "blankRate": "Pusta stawka",
    "blankRateHint": "Wpisz kwotę",
    "fromRateCard": "Z karty stawek",
    "addItem": "Dodaj: {{name}}"
  },
  "ResourceEditorVersionSwitch": {
    "title": "Edytor zasobu",
    "newVersionDescription": "Testujesz nowy edytor. To wciąż wersja eksperymentalna — jeśli coś nie działa, wróć do klasycznej. Twoje dane się nie zmieniają.",
    "oldVersionDescription": "Używasz klasycznego edytora. Nowy jest w wersji beta — możesz go wypróbować w każdej chwili."
  },
  "ResourceNotesPanel": {
    "title": "Notatki",
    "fieldLabel": "Nowa notatka",
    "placeholder": "Napisz notatkę…",
    "submit": "Dodaj notatkę",
    "emptyTitle": "Brak notatek",
    "emptyDescription": "Zapisuj notatki o {{name}}.",
    "fallbackName": "tym zasobie",
    "loadError": "Nie udało się wczytać notatek.",
    "unknownUser": "Nieznany użytkownik",
    "deleteAria": "Usuń notatkę",
    "createdToast": "Notatka dodana",
    "createErrorToast": "Nie udało się dodać notatki",
    "deletedToast": "Notatka usunięta",
    "deleteErrorToast": "Nie udało się usunąć notatki"
  },
  "ResourceFilesPanel": {
    "title": "Dokumenty",
    "emptyTitle": "Brak dokumentów",
    "emptyDescription": "Przechowuj ważne dokumenty i pliki dla {{name}}.",
    "fallbackName": "tego zasobu",
    "loadError": "Nie udało się wczytać dokumentów.",
    "untitled": "Plik bez nazwy",
    "uploadedToast": "Plik przesłany",
    "uploadErrorToast": "Przesyłanie nie powiodło się",
    "deletedToast": "Plik usunięty",
    "deleteErrorToast": "Nie udało się usunąć pliku",
    "reorderErrorToast": "Nie udało się zapisać nowej kolejności"
  },
  "ResourcePane": {
    "invalidDataDescription": "Mimo to pokazujemy ten formularz, ale może działać nieprawidłowo. Jeśli napotkasz problemy, skontaktuj się z pomocą."
  }
}
